(function () {
  const ADDON_VARIANT_ID = Number(document.getElementById("AddonVariantId")?.value || 0);
  if (!ADDON_VARIANT_ID) return;

  const PRINT_SELECT_ID = "PrintSides"; // your select id

  // simple UUID
  function uid() {
    return "pg_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  // Ensure group id exists on page load
  function ensureGroupId() {
    const input = document.getElementById("PrintGroupId");
    if (input && !input.value) input.value = uid();
    return input?.value || "";
  }

  async function cartGet() {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    return r.json();
  }

  async function cartAdd(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });
  }

  async function cartChange(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
  }

  // Reconcile: ONE add-on line per group id, quantity = total qty of matching main items
  async function reconcile(groupId) {
    if (!groupId) return;

    const cart = await cartGet();

    // 1) total main qty that needs add-on (for this group)
    // We detect "needs add-on" by your line item property "Print: 2-sided (+$3)" OR by your select value if you store it.
    // In your cart screenshot you have: "Print: 2-sided (+$3)" so we use that.
    let neededQty = 0;

    cart.items.forEach((it) => {
      const props = it.properties || {};
      if (props._print_group !== groupId) return;
      if (it.variant_id === ADDON_VARIANT_ID) return;

      // match your saved print property text:
      const printVal = props.Print || props["Print"] || "";
      if (String(printVal).includes("2-sided")) {
        neededQty += it.quantity;
      }
    });

    // 2) find all add-on lines for this group
    const addonLines = [];
    cart.items.forEach((it, idx) => {
      const props = it.properties || {};
      if (it.variant_id === ADDON_VARIANT_ID && props._print_group === groupId) {
        addonLines.push({ line: idx + 1, qty: it.quantity });
      }
    });

    // 3) If not needed → remove all add-ons for this group
    if (neededQty === 0) {
      for (const l of addonLines) await cartChange(l.line, 0);
      return;
    }

    // 4) Ensure exactly one add-on line exists
    if (addonLines.length === 0) {
      await cartAdd([
        {
          id: ADDON_VARIANT_ID,
          quantity: neededQty,
          properties: {
            _print_group: groupId,
            "Add-on": "2-sided print (+$3)",
          },
        },
      ]);
      return;
    }

    // 5) If multiple add-on lines, keep first, remove rest
    const keep = addonLines[0];
    for (let i = 1; i < addonLines.length; i++) {
      await cartChange(addonLines[i].line, 0);
    }

    // 6) Set kept add-on qty to neededQty
    await cartChange(keep.line, neededQty);
  }

  // Hook into the product form submit
  document.addEventListener("submit", async function (e) {
    const form = e.target;
    if (!form || !form.matches('form[action^="/cart/add"]')) return;

    // Only run on product page main form (has our PrintSides)
    const printSelect = document.getElementById(PRINT_SELECT_ID);
    if (!printSelect) return;

    const groupId = ensureGroupId();

    // If user chose 2-sided, we let the normal add happen, then reconcile after a short delay.
    // If they chose 1-sided, also reconcile (so it removes add-on if any).
    setTimeout(() => reconcile(groupId), 700);
  });

  // Also reconcile when quantity-break apps do extra cart updates right after add
  // (run again a bit later)
  document.addEventListener("submit", function (e) {
    const printSelect = document.getElementById(PRINT_SELECT_ID);
    if (!printSelect) return;
    const groupId = ensureGroupId();
    setTimeout(() => reconcile(groupId), 1500);
  });

  // Set group id on load
  ensureGroupId();
})();